import { pageHead } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import AdminReferrals from "@/pages/admin/AdminReferrals";

export const Route = createFileRoute("/admin/referrals")({
  head: () => pageHead("Admin \u2014 Referrals \u2014 Modern Fence Install", "Private Modern Fence Install account and management page.", undefined, true),
  component: AdminReferrals,
});
